import { Product } from "@/types";
import { Link, router } from "@inertiajs/react";
import { X } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

interface ListCartProps {
  listProducts: Product[];
}

export const ListCart = ({ listProducts }: ListCartProps) => {

  const handleQuantityChange = (product_id: number, quantity: number) => {
    router.patch('/lists/change_product_quantity', {
      product_id,
      quantity,
    }, {
      preserveScroll: true,
    });
  };

  return (
    <section className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      { listProducts?.length > 0 ? (
        <div className="space-y-3">
          {listProducts.map(p => (
            <div 
              key={p.id} 
              className="flex items-center gap-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition hover:shadow-md"
            >
              <img  
                src={p.primary_image} 
                alt={p.name}
                className="h-16 w-16 flex-shrink-0 rounded-md object-cover"
              />
              
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-900 truncate">
                  {p.name}
                </h3>
                <p className="text-sm text-gray-500">
                  {p.vendor_name}
                </p>
              </div>

              <div className="flex items-center gap-2">
                <label htmlFor={`quantity-${p.id}`} className="text-sm text-gray-600">
                  Ilość:
                </label>
                <Input 
                  id={`quantity-${p.id}`}
                  type="number" 
                  defaultValue={p.quantity || 1}
                  min={1}
                  className="w-16 rounded-md border border-gray-300 px-2 py-1 text-center text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  onChange={(e) => handleQuantityChange(p.id, Number(e.target.value))}
                />
              </div>

              <div className="w-20 text-right">
                <p className="font-semibold text-gray-900">
                  {(p.price * (p?.quantity || 1)).toFixed(2)} zł
                </p>
              </div>

              <Link href="/lists/remove_product_from_list" method="delete" as="div" data={{ product_id: p.id }}>
                <Button 
                  className="flex-shrink-0 rounded-md p-2 text-gray-400 transition hover:bg-red-50 hover:text-red-600 cursor-pointer"
                  aria-label="Usuń produkt"
                >
                  <X className="h-5 w-5"/>
                </Button>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <div>
          <p>Brak produktów na liście</p>
        </div>
      )} 
    </section>
  );
}